// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"3ce2582e","159":"753ba256","408":"5e1a99b7","672":"8a869f9f","833":"90e90aa3"}[chunkId] + ".chunk.js";
};